import { cn } from '#/lib/utils'

/** The original KerjaBareng IP, shared by every brand surface. */
export const MASCOT_SRC = '/brand/mascot.png'

export function Mascot({ className, animated = false, priority = false, alt = '' }: {
  className?: string
  animated?: boolean
  priority?: boolean
  alt?: string
}) {
  return (
    <span className={cn('kb-mascot', animated && 'kb-mascot-welcome', className)}>
      <img src={MASCOT_SRC} alt={alt} aria-hidden={alt ? undefined : true} width={1254} height={1254}
        loading={priority ? 'eager' : 'lazy'} fetchPriority={priority ? 'high' : 'auto'} decoding="async" draggable={false} />
    </span>
  )
}
